module.exports = __webpack_public_path__ + "img/im.be38d2c7.svg";